var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-controll', {
    attrs: {
      "field": _vm.field
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('v-input-text', {
          attrs: {
            "readonly": _vm.readonly,
            "mask": _vm.mask,
            "value": api.getValue(),
            "autocomplete": _vm.autocomplete,
            "type": _vm.type,
            "name": _vm.field,
            "caption": _vm.caption,
            "label": _vm.label,
            "error": api.getTouched() ? api.getError() : undefined,
            "placeholder": _vm.placeholder
          },
          on: {
            "input": api.setValue,
            "blur": api.setTouched
          },
          scopedSlots: _vm._u([{
            key: "error",
            fn: function(props) {
              return [_vm._t("error", [_vm._v(_vm._s(props.error))], {
                error: props.error
              })]
            }
          }, {
            key: "caption",
            fn: function(props) {
              return [_vm._t("caption", [_vm._v(_vm._s(_vm.caption))])]
            }
          }])
        })]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d0dcaa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/baseComponents/Form/FormInput.vue
// module id = 820
// module chunks = 0